import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisibilityFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3837 10.3838C11.2763 9.49115 12.7236 9.49115 13.6162 10.3838C14.5088 11.2764 14.5088 12.7236 13.6162 13.6162C12.7236 14.5089 11.2763 14.5089 10.3837 13.6162C9.49109 12.7236 9.49109 11.2764 10.3837 10.3838Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 4.25C10.0366 4.25 8.13182 5.09876 6.49923 6.36043C4.86253 7.62528 3.44947 9.34213 2.45791 11.1759C2.18099 11.6892 2.18128 12.3104 2.4582 12.8237C3.44975 14.6579 4.86249 16.3744 6.4992 17.6394C8.13181 18.9012 10.0366 19.75 12 19.75C13.9634 19.75 15.8681 18.9012 17.5007 17.6396C19.1374 16.3747 20.5505 14.6579 21.542 12.8241C21.819 12.3108 21.8187 11.6896 21.5417 11.1763C20.5502 9.34208 19.1375 7.62557 17.5007 6.36058C15.8681 5.09876 13.9634 4.25 12 4.25ZM14.6263 9.3736C13.1758 7.92308 10.8241 7.92308 9.37354 9.3736C7.92301 10.8241 7.92301 13.1759 9.37354 14.6264C10.8241 16.0769 13.1758 16.0769 14.6263 14.6264C16.0769 13.1759 16.0769 10.8241 14.6263 9.3736Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgVisibilityFilled);
export default ForwardRef;
